// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/environment.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_audit } from "../../auth/v1/audit_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { CloudConfig } from "./cloud_config_pb";
import { file_chalk_server_v1_cloud_config } from "./cloud_config_pb";
import type { ClusterClass } from "./cluster_class_pb";
import { file_chalk_server_v1_cluster_class } from "./cluster_class_pb";
import type { FieldChange } from "../../utils/v1/field_change_pb";
import { file_chalk_utils_v1_field_change } from "../../utils/v1/field_change_pb";
import { file_chalk_utils_v1_sensitive } from "../../utils/v1/sensitive_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { FieldMask, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/environment.proto.
 */
export const file_chalk_server_v1_environment: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_audit, file_chalk_auth_v1_permissions, file_chalk_server_v1_cloud_config, file_chalk_server_v1_cluster_class, file_chalk_utils_v1_field_change, file_chalk_utils_v1_sensitive, file_google_api_field_behavior, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.EnvironmentObjectStorageConfig
 */
export type EnvironmentObjectStorageConfig = Message<"chalk.server.v1.EnvironmentObjectStorageConfig"> & {
  /**
   * @generated from field: string dataset_bucket = 1;
   */
  datasetBucket: string;

  /**
   * @generated from field: string plan_stages_bucket = 2;
   */
  planStagesBucket: string;

  /**
   * @generated from field: string source_bundle_bucket = 3;
   */
  sourceBundleBucket: string;

  /**
   * @generated from field: string model_registry_bucket = 4;
   */
  modelRegistryBucket: string;
};

/**
 * Describes the message chalk.server.v1.EnvironmentObjectStorageConfig.
 * Use `create(EnvironmentObjectStorageConfigSchema)` to create a new message.
 */
export const EnvironmentObjectStorageConfigSchema: GenMessage<EnvironmentObjectStorageConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 0);

/**
 * @generated from message chalk.server.v1.Environment
 */
export type Environment = Message<"chalk.server.v1.Environment"> & {
  /**
   * The environment name, e.g. "dev", "prod", "staging"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * The environment ID, which is a unique identifier for the environment.
   *
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * @generated from field: string team_id = 4;
   */
  teamId: string;

  /**
   * @generated from field: optional string active_deployment_id = 5;
   */
  activeDeploymentId?: string;

  /**
   * @generated from field: optional string worker_url = 6;
   */
  workerUrl?: string;

  /**
   * @generated from field: optional string service_url = 7;
   */
  serviceUrl?: string;

  /**
   * The base URL to reach the branch server
   *
   * @generated from field: optional string branch_url = 8;
   */
  branchUrl?: string;

  /**
   * @generated from field: optional string offline_store_secret = 9;
   */
  offlineStoreSecret?: string;

  /**
   * TODO(INF-1082): Make output-only once all callers have migrated.
   * Accepts a raw URI or a KMS secret name on writes; reads return the backing KMS name.
   *
   * @generated from field: optional string online_store_secret = 10;
   */
  onlineStoreSecret?: string;

  /**
   * @generated from field: optional string feature_store_secret = 11;
   */
  featureStoreSecret?: string;

  /**
   * @generated from field: optional string postgres_secret = 12;
   */
  postgresSecret?: string;

  /**
   * TODO(INF-1082): Make output-only once all callers have migrated.
   *
   * @generated from field: optional string online_store_kind = 13;
   */
  onlineStoreKind?: string;

  /**
   * @generated from field: optional string emq_uri = 14;
   */
  emqUri?: string;

  /**
   * @generated from field: optional string vpc_connector_name = 15;
   */
  vpcConnectorName?: string;

  /**
   * @generated from field: optional string kube_cluster_name = 16;
   */
  kubeClusterName?: string;

  /**
   * @generated from field: optional string branch_kube_cluster_name = 17;
   */
  branchKubeClusterName?: string;

  /**
   * @generated from field: optional string engine_kube_cluster_name = 18;
   */
  engineKubeClusterName?: string;

  /**
   * @generated from field: optional string shadow_engine_kube_cluster_name = 19;
   */
  shadowEngineKubeClusterName?: string;

  /**
   * @generated from field: optional string kube_job_namespace = 20;
   */
  kubeJobNamespace?: string;

  /**
   * @generated from field: optional string kube_preview_namespace = 21;
   */
  kubePreviewNamespace?: string;

  /**
   * Can be set and updated only for unmanaged environments
   *
   * @generated from field: optional string kube_service_account_name = 22;
   */
  kubeServiceAccountName?: string;

  /**
   * @generated from field: optional string streaming_query_service_uri = 23;
   */
  streamingQueryServiceUri?: string;

  /**
   * @generated from field: bool skip_offline_writes_for_online_cached_features = 24;
   */
  skipOfflineWritesForOnlineCachedFeatures: boolean;

  /**
   * @generated from field: optional string result_bus_topic = 25;
   */
  resultBusTopic?: string;

  /**
   * @generated from field: optional string online_persistence_mode = 26;
   */
  onlinePersistenceMode?: string;

  /**
   * @generated from field: optional string metrics_bus_topic = 27;
   */
  metricsBusTopic?: string;

  /**
   * @generated from field: optional string bigtable_instance_name = 28;
   */
  bigtableInstanceName?: string;

  /**
   * @generated from field: optional string bigtable_table_name = 29;
   */
  bigtableTableName?: string;

  /**
   * @generated from field: optional string cloud_account_locator = 30;
   */
  cloudAccountLocator?: string;

  /**
   * @generated from field: optional string cloud_region = 31;
   */
  cloudRegion?: string;

  /**
   * @generated from field: optional string cloud_tenancy_id = 32;
   */
  cloudTenancyId?: string;

  /**
   * @generated from field: optional string source_bundle_bucket = 33;
   */
  sourceBundleBucket?: string;

  /**
   * @generated from field: optional string engine_docker_registry_path = 34;
   */
  engineDockerRegistryPath?: string;

  /**
   * @generated from field: optional string default_planner = 35;
   */
  defaultPlanner?: string;

  /**
   * Customer-supplied env vars injected verbatim into engine pods; they
   * routinely carry datasource credentials, so redact from the audit log.
   *
   * @generated from field: map<string, string> additional_env_vars = 36;
   */
  additionalEnvVars: { [key: string]: string };

  /**
   * @generated from field: map<string, string> additional_cron_env_vars = 37;
   */
  additionalCronEnvVars: { [key: string]: string };

  /**
   * May embed pip index URLs with tokens in the userinfo.
   *
   * @generated from field: optional string private_pip_repositories = 38;
   */
  privatePipRepositories?: string;

  /**
   * @generated from field: bool is_sandbox = 39;
   */
  isSandbox: boolean;

  /**
   * AWS/GCP
   *
   * @generated from field: chalk.server.v1.CloudProviderKind cloud_provider = 41;
   */
  cloudProvider: CloudProviderKind;

  /**
   * Null if the environment is hosted by Chalk.
   *
   * @generated from field: optional chalk.server.v1.CloudConfig cloud_config = 42;
   */
  cloudConfig?: CloudConfig;

  /**
   * TODO: really a structured object.
   *
   * @generated from field: map<string, google.protobuf.Value> spec_config_json = 40;
   */
  specConfigJson: { [key: string]: Value };

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 43;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional string metadata_server_metrics_store_secret = 44;
   */
  metadataServerMetricsStoreSecret?: string;

  /**
   * @generated from field: optional string query_server_metrics_store_secret = 45;
   */
  queryServerMetricsStoreSecret?: string;

  /**
   * @generated from field: optional string pinned_base_image = 46;
   */
  pinnedBaseImage?: string;

  /**
   * @generated from field: optional string cluster_gateway_id = 47;
   */
  clusterGatewayId?: string;

  /**
   * @generated from field: optional string cluster_timescaledb_id = 48;
   */
  clusterTimescaledbId?: string;

  /**
   * @generated from field: optional string background_persistence_deployment_id = 49;
   */
  backgroundPersistenceDeploymentId?: string;

  /**
   * Workflow Orchestrator Engine deployment linked to this environment.
   *
   * @generated from field: optional string cluster_workflow_orchestrator_id = 64;
   */
  clusterWorkflowOrchestratorId?: string;

  /**
   * @generated from field: optional chalk.server.v1.EnvironmentObjectStorageConfig environment_buckets = 50;
   */
  environmentBuckets?: EnvironmentObjectStorageConfig;

  /**
   * @generated from field: optional string cluster_timescaledb_secret = 51;
   */
  clusterTimescaledbSecret?: string;

  /**
   * @generated from field: optional string grpc_engine_url = 52;
   */
  grpcEngineUrl?: string;

  /**
   * Can be set and updated only for unmanaged environments
   *
   * @generated from field: optional string kube_cluster_mode = 53;
   */
  kubeClusterMode?: string;

  /**
   * @generated from field: optional string dashboard_url = 54;
   */
  dashboardUrl?: string;

  /**
   * @generated from field: optional string kube_cluster_id = 55;
   */
  kubeClusterId?: string;

  /**
   * @generated from field: optional bool managed = 56;
   */
  managed?: boolean;

  /**
   * @generated from field: optional string telemetry_deployment_id = 57;
   */
  telemetryDeploymentId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp suspended_at = 58;
   */
  suspendedAt?: Timestamp;

  /**
   * @generated from field: optional chalk.server.v1.DeploymentBuildProfile default_build_profile = 59;
   */
  defaultBuildProfile?: DeploymentBuildProfile;

  /**
   * @generated from field: optional chalk.server.v1.VectorDBKind vector_db_kind = 60;
   */
  vectorDbKind?: VectorDBKind;

  /**
   * @generated from field: optional string vector_db_secret = 61;
   */
  vectorDbSecret?: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> internal_metadata = 62;
   */
  internalMetadata: { [key: string]: Value };

  /**
   * @generated from field: map<string, google.protobuf.Value> customer_metadata = 63;
   */
  customerMetadata: { [key: string]: Value };

  /**
   * @generated from field: optional string dataplane_db_direct_secret = 65;
   */
  dataplaneDbDirectSecret?: string;

  /**
   * @generated from field: chalk.server.v1.ClusterClass primary_linked_cluster_class = 66;
   */
  primaryLinkedClusterClass: ClusterClass;

  /**
   * @generated from field: optional string description = 67;
   */
  description?: string;

  /**
   * @generated from field: optional string default_engine_base_image = 68;
   */
  defaultEngineBaseImage?: string;

  /**
   * @generated from field: optional string default_ai_provider_connection_id = 69;
   */
  defaultAiProviderConnectionId?: string;

  /**
   * @generated from field: optional chalk.server.v1.EnvironmentSuspensionSource suspension_source = 70;
   */
  suspensionSource?: EnvironmentSuspensionSource;
};

/**
 * Describes the message chalk.server.v1.Environment.
 * Use `create(EnvironmentSchema)` to create a new message.
 */
export const EnvironmentSchema: GenMessage<Environment> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 1);

/**
 * @generated from message chalk.server.v1.CreateEnvironmentV2Request
 */
export type CreateEnvironmentV2Request = Message<"chalk.server.v1.CreateEnvironmentV2Request"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message chalk.server.v1.CreateEnvironmentV2Request.
 * Use `create(CreateEnvironmentV2RequestSchema)` to create a new message.
 */
export const CreateEnvironmentV2RequestSchema: GenMessage<CreateEnvironmentV2Request> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 2);

/**
 * @generated from message chalk.server.v1.CreateEnvironmentV2Response
 */
export type CreateEnvironmentV2Response = Message<"chalk.server.v1.CreateEnvironmentV2Response"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;
};

/**
 * Describes the message chalk.server.v1.CreateEnvironmentV2Response.
 * Use `create(CreateEnvironmentV2ResponseSchema)` to create a new message.
 */
export const CreateEnvironmentV2ResponseSchema: GenMessage<CreateEnvironmentV2Response> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 3);

/**
 * @generated from message chalk.server.v1.SelfServiceCreateTeamAndEnvironmentRequest
 */
export type SelfServiceCreateTeamAndEnvironmentRequest = Message<"chalk.server.v1.SelfServiceCreateTeamAndEnvironmentRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string team_name = 2;
   */
  teamName: string;

  /**
   * A browser attempt already bound to this user by the metadata-service caller.
   *
   * @generated from field: optional string signup_link_attempt_id = 3;
   */
  signupLinkAttemptId?: string;

  /**
   * Defaults to "default".
   *
   * @generated from field: optional string environment_name = 4;
   */
  environmentName?: string;

  /**
   * Defaults to the signup grant's restriction, then us-east4 when unrestricted.
   *
   * @generated from field: optional string region = 5;
   */
  region?: string;

  /**
   * Omit for individual signups; a nonblank company name selects DPA terms.
   *
   * @generated from field: optional string company_name = 6;
   */
  companyName?: string;
};

/**
 * Describes the message chalk.server.v1.SelfServiceCreateTeamAndEnvironmentRequest.
 * Use `create(SelfServiceCreateTeamAndEnvironmentRequestSchema)` to create a new message.
 */
export const SelfServiceCreateTeamAndEnvironmentRequestSchema: GenMessage<SelfServiceCreateTeamAndEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 4);

/**
 * @generated from message chalk.server.v1.SelfServiceCreateTeamAndEnvironmentResponse
 */
export type SelfServiceCreateTeamAndEnvironmentResponse = Message<"chalk.server.v1.SelfServiceCreateTeamAndEnvironmentResponse"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: chalk.server.v1.Environment environment = 3;
   */
  environment?: Environment;
};

/**
 * Describes the message chalk.server.v1.SelfServiceCreateTeamAndEnvironmentResponse.
 * Use `create(SelfServiceCreateTeamAndEnvironmentResponseSchema)` to create a new message.
 */
export const SelfServiceCreateTeamAndEnvironmentResponseSchema: GenMessage<SelfServiceCreateTeamAndEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 5);

/**
 * @generated from message chalk.server.v1.UpdateEnvironmentV2Request
 */
export type UpdateEnvironmentV2Request = Message<"chalk.server.v1.UpdateEnvironmentV2Request"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.UpdateEnvironmentV2Request.
 * Use `create(UpdateEnvironmentV2RequestSchema)` to create a new message.
 */
export const UpdateEnvironmentV2RequestSchema: GenMessage<UpdateEnvironmentV2Request> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 6);

/**
 * @generated from message chalk.server.v1.UpdateEnvironmentV2Response
 */
export type UpdateEnvironmentV2Response = Message<"chalk.server.v1.UpdateEnvironmentV2Response"> & {
  /**
   * @generated from field: chalk.server.v1.Environment environment = 1;
   */
  environment?: Environment;

  /**
   * @generated from field: repeated chalk.utils.v1.FieldChange field_changes = 2;
   */
  fieldChanges: FieldChange[];
};

/**
 * Describes the message chalk.server.v1.UpdateEnvironmentV2Response.
 * Use `create(UpdateEnvironmentV2ResponseSchema)` to create a new message.
 */
export const UpdateEnvironmentV2ResponseSchema: GenMessage<UpdateEnvironmentV2Response> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 7);

/**
 * @generated from message chalk.server.v1.DeleteEnvironmentRequest
 */
export type DeleteEnvironmentRequest = Message<"chalk.server.v1.DeleteEnvironmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Delete the Metrics DB attached to a managed environment before deleting the environment.
   * The dashboard sets this for its all-in-one lifecycle, while Terraform leaves it unset so the
   * Metrics DB remains under Terraform's control.
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message chalk.server.v1.DeleteEnvironmentRequest.
 * Use `create(DeleteEnvironmentRequestSchema)` to create a new message.
 */
export const DeleteEnvironmentRequestSchema: GenMessage<DeleteEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 8);

/**
 * @generated from message chalk.server.v1.DeleteEnvironmentResponse
 */
export type DeleteEnvironmentResponse = Message<"chalk.server.v1.DeleteEnvironmentResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteEnvironmentResponse.
 * Use `create(DeleteEnvironmentResponseSchema)` to create a new message.
 */
export const DeleteEnvironmentResponseSchema: GenMessage<DeleteEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 9);

/**
 * @generated from message chalk.server.v1.SetDefaultEnvironmentRequest
 */
export type SetDefaultEnvironmentRequest = Message<"chalk.server.v1.SetDefaultEnvironmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.SetDefaultEnvironmentRequest.
 * Use `create(SetDefaultEnvironmentRequestSchema)` to create a new message.
 */
export const SetDefaultEnvironmentRequestSchema: GenMessage<SetDefaultEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 10);

/**
 * @generated from message chalk.server.v1.SetDefaultEnvironmentResponse
 */
export type SetDefaultEnvironmentResponse = Message<"chalk.server.v1.SetDefaultEnvironmentResponse"> & {
};

/**
 * Describes the message chalk.server.v1.SetDefaultEnvironmentResponse.
 * Use `create(SetDefaultEnvironmentResponseSchema)` to create a new message.
 */
export const SetDefaultEnvironmentResponseSchema: GenMessage<SetDefaultEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 11);

/**
 * Probe result for a single capability against a bucket.
 *
 * @generated from message chalk.server.v1.DiscoveredBucketProbe
 */
export type DiscoveredBucketProbe = Message<"chalk.server.v1.DiscoveredBucketProbe"> & {
  /**
   * Whether the capability was successfully exercised against the bucket.
   *
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * If !ok, the human-readable reason. Always empty if the probe was skipped.
   *
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * If true, the probe was not attempted (e.g. no cloud credentials, mock bucket,
   * or unsupported cloud provider). In this case ok is false and error is empty.
   *
   * @generated from field: bool skipped = 3;
   */
  skipped: boolean;
};

/**
 * Describes the message chalk.server.v1.DiscoveredBucketProbe.
 * Use `create(DiscoveredBucketProbeSchema)` to create a new message.
 */
export const DiscoveredBucketProbeSchema: GenMessage<DiscoveredBucketProbe> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 12);

/**
 * @generated from message chalk.server.v1.DiscoveredBucket
 */
export type DiscoveredBucket = Message<"chalk.server.v1.DiscoveredBucket"> & {
  /**
   * The bucket URI / name as configured (e.g. "gs://my-bucket", "s3://...", or
   * a plain bucket name).
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Stable role identifier (e.g. DATASET, PLAN_STAGES, DEBUG, etc.).
   *
   * @generated from field: chalk.server.v1.DiscoveredBucketRole role = 2;
   */
  role: DiscoveredBucketRole;

  /**
   * Human-readable label for this bucket's role.
   *
   * @generated from field: string role_label = 3;
   */
  roleLabel: string;

  /**
   * The plane / subsystem that uses this bucket.
   *
   * @generated from field: chalk.server.v1.DiscoveredBucketSource source = 4;
   */
  source: DiscoveredBucketSource;

  /**
   * The configuration key that produced this bucket (e.g. an env var name,
   * an environment_buckets field, etc.). Useful for debugging.
   *
   * @generated from field: string config_key = 5;
   */
  configKey: string;

  /**
   * Probe of read permission against this bucket (e.g. HeadBucket on S3).
   *
   * @generated from field: chalk.server.v1.DiscoveredBucketProbe read = 6;
   */
  read?: DiscoveredBucketProbe;

  /**
   * Probe of write permission against this bucket (small write+delete).
   *
   * @generated from field: chalk.server.v1.DiscoveredBucketProbe write = 7;
   */
  write?: DiscoveredBucketProbe;

  /**
   * Whether this bucket is configured per-environment or shared at the cluster level.
   *
   * @generated from field: chalk.server.v1.DiscoveredBucketScope scope = 8;
   */
  scope: DiscoveredBucketScope;
};

/**
 * Describes the message chalk.server.v1.DiscoveredBucket.
 * Use `create(DiscoveredBucketSchema)` to create a new message.
 */
export const DiscoveredBucketSchema: GenMessage<DiscoveredBucket> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 13);

/**
 * @generated from message chalk.server.v1.DiscoverEnvironmentBucketsRequest
 */
export type DiscoverEnvironmentBucketsRequest = Message<"chalk.server.v1.DiscoverEnvironmentBucketsRequest"> & {
  /**
   * If true, only the configured bucket list is returned without performing any
   * live read/write probes. Useful when the caller does not want the latency or
   * side-effects of probing.
   *
   * @generated from field: bool skip_probes = 1;
   */
  skipProbes: boolean;
};

/**
 * Describes the message chalk.server.v1.DiscoverEnvironmentBucketsRequest.
 * Use `create(DiscoverEnvironmentBucketsRequestSchema)` to create a new message.
 */
export const DiscoverEnvironmentBucketsRequestSchema: GenMessage<DiscoverEnvironmentBucketsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 14);

/**
 * @generated from message chalk.server.v1.DiscoverEnvironmentBucketsResponse
 */
export type DiscoverEnvironmentBucketsResponse = Message<"chalk.server.v1.DiscoverEnvironmentBucketsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.DiscoveredBucket buckets = 1;
   */
  buckets: DiscoveredBucket[];
};

/**
 * Describes the message chalk.server.v1.DiscoverEnvironmentBucketsResponse.
 * Use `create(DiscoverEnvironmentBucketsResponseSchema)` to create a new message.
 */
export const DiscoverEnvironmentBucketsResponseSchema: GenMessage<DiscoverEnvironmentBucketsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_environment, 15);

/**
 * @generated from enum chalk.server.v1.EnvironmentSuspensionSource
 */
export enum EnvironmentSuspensionSource {
  /**
   * @generated from enum value: ENVIRONMENT_SUSPENSION_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENVIRONMENT_SUSPENSION_SOURCE_CUSTOMER = 1;
   */
  CUSTOMER = 1,

  /**
   * @generated from enum value: ENVIRONMENT_SUSPENSION_SOURCE_ADMIN = 2;
   */
  ADMIN = 2,
}

/**
 * Describes the enum chalk.server.v1.EnvironmentSuspensionSource.
 */
export const EnvironmentSuspensionSourceSchema: GenEnum<EnvironmentSuspensionSource> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment, 0);

/**
 * @generated from enum chalk.server.v1.CloudProviderKind
 */
export enum CloudProviderKind {
  /**
   * @generated from enum value: CLOUD_PROVIDER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLOUD_PROVIDER_KIND_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: CLOUD_PROVIDER_KIND_GCP = 2;
   */
  GCP = 2,

  /**
   * @generated from enum value: CLOUD_PROVIDER_KIND_AWS = 3;
   */
  AWS = 3,

  /**
   * @generated from enum value: CLOUD_PROVIDER_KIND_AZURE = 4;
   */
  AZURE = 4,

  /**
   * @generated from enum value: CLOUD_PROVIDER_KIND_LOCAL = 5;
   */
  LOCAL = 5,
}

/**
 * Describes the enum chalk.server.v1.CloudProviderKind.
 */
export const CloudProviderKindSchema: GenEnum<CloudProviderKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment, 1);

/**
 * @generated from enum chalk.server.v1.VectorDBKind
 */
export enum VectorDBKind {
  /**
   * @generated from enum value: VECTOR_DB_KIND_UNSPECIFIED = 0;
   */
  VECTOR_DB_KIND_UNSPECIFIED = 0,

  /**
   * @generated from enum value: VECTOR_DB_KIND_OPENSEARCH = 1;
   */
  VECTOR_DB_KIND_OPENSEARCH = 1,

  /**
   * @generated from enum value: VECTOR_DB_KIND_PGVECTOR = 2;
   */
  VECTOR_DB_KIND_PGVECTOR = 2,

  /**
   * @generated from enum value: VECTOR_DB_KIND_MILVUS = 3;
   */
  VECTOR_DB_KIND_MILVUS = 3,

  /**
   * @generated from enum value: VECTOR_DB_KIND_VALKEY = 4;
   */
  VECTOR_DB_KIND_VALKEY = 4,

  /**
   * @generated from enum value: VECTOR_DB_KIND_TURBOPUFFER = 5;
   */
  VECTOR_DB_KIND_TURBOPUFFER = 5,

  /**
   * @generated from enum value: VECTOR_DB_KIND_S3_VECTORS = 6;
   */
  VECTOR_DB_KIND_S3_VECTORS = 6,
}

/**
 * Describes the enum chalk.server.v1.VectorDBKind.
 */
export const VectorDBKindSchema: GenEnum<VectorDBKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment, 2);

/**
 * @generated from enum chalk.server.v1.DeploymentBuildProfile
 */
export enum DeploymentBuildProfile {
  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_NO_PROFILING = 1;
   */
  O3_NO_PROFILING = 1,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_PROFILING = 2;
   */
  O3_PROFILING = 2,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_NO_PROFILING = 3;
   */
  O2_NO_PROFILING = 3,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_PROFILING = 4;
   */
  O2_PROFILING = 4,

  /**
   * Legacy Rust-layered profiles are retained for stored deployments.
   *
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_RUST_NO_PROFILING = 5 [deprecated = true];
   * @deprecated
   */
  O3_RUST_NO_PROFILING = 5,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_RUST_PROFILING = 6 [deprecated = true];
   * @deprecated
   */
  O3_RUST_PROFILING = 6,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_RUST_NO_PROFILING = 7 [deprecated = true];
   * @deprecated
   */
  O2_RUST_NO_PROFILING = 7,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_RUST_PROFILING = 8 [deprecated = true];
   * @deprecated
   */
  O2_RUST_PROFILING = 8,

  /**
   * Legacy distroless Bazel and Bazel+Rust profiles are retained for stored deployments.
   *
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_BAZEL_NO_PROFILING = 9 [deprecated = true];
   * @deprecated
   */
  O3_BAZEL_NO_PROFILING = 9,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_BAZEL_PROFILING = 10 [deprecated = true];
   * @deprecated
   */
  O3_BAZEL_PROFILING = 10,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_BAZEL_NO_PROFILING = 11 [deprecated = true];
   * @deprecated
   */
  O2_BAZEL_NO_PROFILING = 11,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_BAZEL_PROFILING = 12 [deprecated = true];
   * @deprecated
   */
  O2_BAZEL_PROFILING = 12,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_BAZEL_RUST_NO_PROFILING = 13 [deprecated = true];
   * @deprecated
   */
  O3_BAZEL_RUST_NO_PROFILING = 13,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_BAZEL_RUST_PROFILING = 14 [deprecated = true];
   * @deprecated
   */
  O3_BAZEL_RUST_PROFILING = 14,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_BAZEL_RUST_NO_PROFILING = 15 [deprecated = true];
   * @deprecated
   */
  O2_BAZEL_RUST_NO_PROFILING = 15,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_BAZEL_RUST_PROFILING = 16 [deprecated = true];
   * @deprecated
   */
  O2_BAZEL_RUST_PROFILING = 16,

  /**
   * _BAZEL_DEBIAN_ variants select the Debian-userspace flavor of the Bazel
   * engine base image (for example, bazel-staging-engine-base-312-debian).
   * It carries the engine layers on a base with an apt closure mirroring the
   * non-Bazel engine image, so a running pod has a shell, debug tooling, and
   * the headers customer sdists compile against at deploy time. The modern
   * O3 image is published for Python 3.11, 3.12, and 3.13. There is no
   * non-Bazel _DEBIAN_ variant or _BAZEL_RUST_DEBIAN_ variant.
   *
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_BAZEL_DEBIAN_NO_PROFILING = 17;
   */
  O3_BAZEL_DEBIAN_NO_PROFILING = 17,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O3_BAZEL_DEBIAN_PROFILING = 18;
   */
  O3_BAZEL_DEBIAN_PROFILING = 18,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_BAZEL_DEBIAN_NO_PROFILING = 19;
   */
  O2_BAZEL_DEBIAN_NO_PROFILING = 19,

  /**
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_O2_BAZEL_DEBIAN_PROFILING = 20;
   */
  O2_BAZEL_DEBIAN_PROFILING = 20,

  /**
   * MODERN builds like O3_BAZEL_DEBIAN_NO_PROFILING and also deploys in the "modern"
   * deployment mode: the unconstrained customer venv isolated from the subprocess
   * invoker venv, and HTTP served by chalk-http-engine-proxy inside the engine-grpc
   * pod with the standalone engine scaled to zero. As an environment's default build
   * profile, it makes every ordinary deploy of that environment modern.
   *
   * @generated from enum value: DEPLOYMENT_BUILD_PROFILE_MODERN = 21;
   */
  MODERN = 21,
}

/**
 * Describes the enum chalk.server.v1.DeploymentBuildProfile.
 */
export const DeploymentBuildProfileSchema: GenEnum<DeploymentBuildProfile> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment, 3);

/**
 * The plane / subsystem that referenced a bucket. Used to indicate where Chalk
 * learned about the bucket from when discovering buckets.
 *
 * @generated from enum chalk.server.v1.DiscoveredBucketSource
 */
export enum DiscoveredBucketSource {
  /**
   * @generated from enum value: DISCOVERED_BUCKET_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_SOURCE_ENGINE = 1;
   */
  ENGINE = 1,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_SOURCE_METADATA_PLANE = 2;
   */
  METADATA_PLANE = 2,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_SOURCE_CLUSTER_MANAGER = 3;
   */
  CLUSTER_MANAGER = 3,
}

/**
 * Describes the enum chalk.server.v1.DiscoveredBucketSource.
 */
export const DiscoveredBucketSourceSchema: GenEnum<DiscoveredBucketSource> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment, 4);

/**
 * Whether a discovered bucket is configured per-environment or shared at the
 * cluster level. Environment-scoped config applies to a single environment;
 * cluster-scoped config is shared by every environment on the cluster (e.g. a
 * cluster cloud_storage_binding or a cluster-manager env var).
 *
 * @generated from enum chalk.server.v1.DiscoveredBucketScope
 */
export enum DiscoveredBucketScope {
  /**
   * @generated from enum value: DISCOVERED_BUCKET_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_SCOPE_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_SCOPE_CLUSTER = 2;
   */
  CLUSTER = 2,
}

/**
 * Describes the enum chalk.server.v1.DiscoveredBucketScope.
 */
export const DiscoveredBucketScopeSchema: GenEnum<DiscoveredBucketScope> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment, 5);

/**
 * The purpose / role of a bucket within the Chalk deployment. Used so the UI
 * can render a stable label per bucket regardless of the underlying name.
 *
 * @generated from enum chalk.server.v1.DiscoveredBucketRole
 */
export enum DiscoveredBucketRole {
  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_DATASET = 1;
   */
  DATASET = 1,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_PLAN_STAGES = 2;
   */
  PLAN_STAGES = 2,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_DEBUG = 3;
   */
  DEBUG = 3,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_DATA_TRANSFER = 4;
   */
  DATA_TRANSFER = 4,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_SNOWFLAKE_UNLOAD = 5;
   */
  SNOWFLAKE_UNLOAD = 5,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_VOLUME = 6;
   */
  VOLUME = 6,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_SOURCE_BUNDLE = 7;
   */
  SOURCE_BUNDLE = 7,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_MODEL_REGISTRY = 8;
   */
  MODEL_REGISTRY = 8,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_INGESTER_SNAPSHOT = 9;
   */
  INGESTER_SNAPSHOT = 9,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_STREAMING_LOG = 10;
   */
  STREAMING_LOG = 10,

  /**
   * @generated from enum value: DISCOVERED_BUCKET_ROLE_OTHER = 11;
   */
  OTHER = 11,
}

/**
 * Describes the enum chalk.server.v1.DiscoveredBucketRole.
 */
export const DiscoveredBucketRoleSchema: GenEnum<DiscoveredBucketRole> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_environment, 6);

/**
 * Note that the RPCs in this service supersede those in the team service for environments.
 *
 * @generated from service chalk.server.v1.EnvironmentService
 */
export const EnvironmentService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.EnvironmentService.SelfServiceCreateTeamAndEnvironment
   */
  selfServiceCreateTeamAndEnvironment: {
    methodKind: "unary";
    input: typeof SelfServiceCreateTeamAndEnvironmentRequestSchema;
    output: typeof SelfServiceCreateTeamAndEnvironmentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentService.CreateEnvironmentV2
   */
  createEnvironmentV2: {
    methodKind: "unary";
    input: typeof CreateEnvironmentV2RequestSchema;
    output: typeof CreateEnvironmentV2ResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentService.UpdateEnvironmentV2
   */
  updateEnvironmentV2: {
    methodKind: "unary";
    input: typeof UpdateEnvironmentV2RequestSchema;
    output: typeof UpdateEnvironmentV2ResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentService.DeleteEnvironment
   */
  deleteEnvironment: {
    methodKind: "unary";
    input: typeof DeleteEnvironmentRequestSchema;
    output: typeof DeleteEnvironmentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentService.SetDefaultEnvironment
   */
  setDefaultEnvironment: {
    methodKind: "unary";
    input: typeof SetDefaultEnvironmentRequestSchema;
    output: typeof SetDefaultEnvironmentResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.EnvironmentService.DiscoverEnvironmentBuckets
   */
  discoverEnvironmentBuckets: {
    methodKind: "unary";
    input: typeof DiscoverEnvironmentBucketsRequestSchema;
    output: typeof DiscoverEnvironmentBucketsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_environment, 0);

